import { createContext, useContext, ReactNode, useState } from 'react';

interface TopMargin {
  base: string;
  md: string;
}

interface LayoutContextProps {
  contentHeight: {
    base: string;
    md: string;
  };
  setLayout: (topMargin: TopMargin) => void;
}

const LayoutContext = createContext<LayoutContextProps | undefined>(undefined);

export const useLayout = (): LayoutContextProps => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};

interface LayoutProviderProps {
  children: ReactNode;
}

export const LayoutProvider: React.FC<LayoutProviderProps> = ({ children }) => {
  const [contentHeight, setContentHeight] = useState<{base: string, md: string}>({
    base: 'calc(100vh - 30px)',
    md: 'calc(100vh - 30px)'
  });

  const setLayout = (topMargin: TopMargin) => {
    setContentHeight({
      base: `calc(100vh - ${topMargin.base})`,
      md: `calc(100vh - ${topMargin.md})`
    });
  };

  return (
    <LayoutContext.Provider value={{ contentHeight, setLayout }}>
      {children}
    </LayoutContext.Provider>
  );
};